var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"pa-4",attrs:{"max-width":"400"}},[_c('v-card-text',{staticClass:"pt-0"},[_c('div',{staticClass:"title font-weight-light mb-2"},[_vm._v("Documents processats")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }